module.exports = __webpack_public_path__ + "static/media/404-bg.fdc3f5d1.png";